// @flow

import { get } from 'lodash';

import createReducer from '../utils/createReducer';
import {
  API_CALL_SUCCESS,
  API_CALL_REQUEST,
  API_CALL_FAILURE,
  RESET_JACKPOT_SLOTS,
  STOP_JACKPOT_SLOTS_SPINNING
} from '../constants/actionTypes';
import {
  JACKPOT_SLOTS,
  JACKPOT_SLOTS_GET_WINNERS,
  USER_DETAILS,
  USER_SIGN_IN
} from '../constants/apiTypes';

const initialState = {
  errors: [],
  initialJackpotAmount: 0,
  isFetchingSpins: false,
  isPosting: false,
  isSpinning: false,
  spinsRemaining: null,
  unlockTime: null,
  winAmount: 0,
  winners: []
};

const jackpotSlotsReducer = createReducer(initialState, {
  [API_CALL_REQUEST]: (state, action) => {
    switch (action.api) {
      case JACKPOT_SLOTS:
        return {
          errors: [],
          isPosting: true,
          isSpinning: true
        };
      default:
        return {};
    }
  },
  [API_CALL_SUCCESS]: (state, action) => {
    switch (action.api) {
      case JACKPOT_SLOTS:
        return {
          isPosting: false,
          winAmount: action.data.amount,
          spinsRemaining: action.meta.jackpot_slot_status.count
        };
      case JACKPOT_SLOTS_GET_WINNERS:
        return {
          winners: action.data,
          initialJackpotAmount: action.meta.jackpot_amount
        };
      case USER_SIGN_IN:
      case USER_DETAILS:
        return {
          spinsRemaining: get(action, 'data.jackpot_slot_status.count'),
          unlockTime: get(action, 'data.jackpot_slot_status.next_bonus_at')
        };
      default:
        return {};
    }
  },
  [API_CALL_FAILURE]: (state, action) => {
    switch (action.api) {
      case JACKPOT_SLOTS:
        return {
          isPosting: false,
          winAmount: 0,
          spinsRemaining: action.meta.jackpot_slot_status.count,
          errors: get(action, 'errors.messages', [])
        };
      default:
        return {};
    }
  },
  [STOP_JACKPOT_SLOTS_SPINNING]: () => ({
    isSpinning: false
  }),
  [RESET_JACKPOT_SLOTS]: () => ({
    errors: [],
    isFetchingSpins: false,
    isPosting: false,
    isSpinning: false,
    winAmount: 0
  })
});

export default jackpotSlotsReducer;
